import {Injectable} from '@angular/core';
import {ApiService, JwtService} from '@common-lib';
import {map} from 'rxjs/operators';
import {catchError} from "rxjs/operators/catchError";
import {ErrorObservable} from "rxjs/observable/ErrorObservable";
import {Router} from "@angular/router";

@Injectable()
export class SettingsService {

    constructor(
        private api: ApiService,
        private router: Router,
        private jwtService: JwtService
    ) {}

    getSettings() {
        return this.api.get('/admin/settings').pipe(map(({result}) => result));
    }

    getPublishStatus(version: string) {
        const url = `/admin/status/${version}`;
        return this.api.get(url).pipe(map(({result}) => result));
    }

    saveSettings(data) {
        return this.api.put('/admin/settings', data).pipe(map(({result}) => result));
    }

    uploadFile(fileToUpload: File, pathToFolder) {
        const apiPath = '/filemanager/image-package';
        const formData: FormData = new FormData();
        formData.append('file', fileToUpload, fileToUpload.name);
        return this.api.uploadFile(formData, pathToFolder, fileToUpload.name, apiPath);
    }

    uploadExistingPackage(id) {
        const apiPath = '/filemanager/image-package';
        const pathToFolder = 'assets';
        return this.api.post(apiPath, {}, { id: id.toString(), pathToFolder });
    }

    loadPublishVersionsList() {
        return this.api.get('/admin/publish').pipe(map(({result}) => result), catchError(err => this.formatErrors(err, this.jwtService, this.router)));
    }

    publish(version: string, locale: any, products: any) {
        return this.api.post('/admin/publish', {
            version,
            locale,
            products
        }).pipe(map(({result}) => result), catchError(err => this.formatErrors(err, this.jwtService, this.router)));
    }

  private formatErrors(error: any, jwt, router) {
    if(error.status === 401) {
      jwt.destroyToken();
      router.navigate(['/login']);
      document.location.reload(true);
    }
    return new ErrorObservable(error.error);
  }

  collectAllCache() {
        return this.api.post('/admin/collect-all-cache').pipe(map(({result}) => result));
    }

  convertSettings() {
    return this.api.post('/admin/collect-all-cache', {'mode': 'convert'}).pipe(map(({result}) => result));
  }

}



// WEBPACK FOOTER //
// ./src/app/pages-services/settings.service.ts